/**
 * SilkTale 品牌 - Home 页面配置
 */
import { homeCommonConfig } from './common'
import type { HomePageConfig } from './types'

export const theme = {
  // 首页背景图
  homeBg: '/images/silktale/home-bg.webp',
  // 标签模块背景图
  tagsBg: '/images/silktale/tag-background.webp',

  // 标签按钮选中状态 (使用品牌主色)
  tagActiveBg: '#FD9540',
  tagActiveText: '#FFFFFF',

  // 标签按钮未选中状态
  tagInactiveBg: '#FFF7ED',
  tagInactiveText: '#FD9540',

  // Tab 激活状态渐变底部装饰线
  tabActiveGradient: 'linear-gradient(270deg, #F6F7F9 0%, #FD9540 95%)',
  // Tab 激活状态文字和下划线颜色
  tabActiveColor: '#FD9540',
  // sticky-header 背景渐变
  stickyHeaderBg: 'linear-gradient(180deg, #FFF0E4 0%, #FFFFFF 100%)',
  // 顶部 Banner 撑满屏宽，无底部圆角
  topBannerRadius: '0',
} as const

export const homeConfig: HomePageConfig = {
  theme,
  texts: homeCommonConfig.texts,
}
